module.exports = __webpack_public_path__ + "img/7f.dc5de5ed.png";